export function getCharCount(str) {
    return str.length;
}

export function getWordCount(str) {
    return str.trim().split(/\s+/).length;
}

export function trimSpaces(str) {
    return str.replace(/(^\s*)|(\s*$)/gi, '');
}
